import ExpandMore from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Button, Drawer, FormControl, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ItemPropertiesDelimiterInput from '../../../ItemPropertiesDelimiterInput';
import { useSelector } from 'react-redux';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

function DataValidationCustomizeScreen({open, setOpenCustomizeModal, setDelimiterValue }) {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx)
  const delimiter = useSelector(
    (state) => state.treeData[parentScreen].dataValidationDelim
  );
  const [recordDelimiterValue, setRecordDelimiterValue] = useState("");
  const [fieldDelimiterValue, setFieldDelimiterValue] = useState("");
  const [delimiters, setDelimiters] = useState({})
  const drawerWidth = 450;
  
  const handleDone = () => {
    setDelimiterValue(delimiters)
    setOpenCustomizeModal(false);
  }
  
  const handleBackdropClick = (event, reason) => {
    if (reason === "backdropClick") return;
  };
  
  useEffect(() => {
    setDelimiters({
        recordDelimiter: delimiter.dataValiadtionRecordDelim, 
        fieldDelimiter: delimiter.dataValiadtionFieldDelim})

  },[delimiter])
  return (
    <>
      <Drawer
        anchor="left"
        open={open}
        onClose={() => setOpenCustomizeModal(false)}
        ModalProps={{
          onClose: handleBackdropClick,
        }}
        SlideProps={{
          style: { transform: open ? "translateX(0)" : "translateX(-240px)" },
        }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            boxShadow: "none",
            overflow: "hidden",
          },
        }}>
        <div
          className="flex-column height-100"
          style={{ backgroundColor: "#fff", position: "relative" }}>
          <div className="quick-add-container padding-16">
            <div style={{ lineHeight: "25px" }}>
              <p style={{ marginBottom: "10px" }}>
                {t("DIAG_QUICK_CODESET_ADD_CUSTOMIZER_TIT")}
              </p>
              <div className="font-12">
                <p>{t("DIAG_QUICK_FIELD_ADD_CUSTOMIZER_DESC")}</p>
              </div>
            </div>
          </div>
          <div style={{ padding: "16px", flex: 1 }}>
            <div
              style={{
                overflow: "auto",
                border: "solid 1px #eeeeee",
                borderRadius: "5px",
                borderTopRightRadius: "5px",
              }}>
              <Accordion expanded={true}>
                <AccordionSummary >
                  <Typography
                    sx={{ width: "53%", flexShrink: 0, fontWeight: 800 }}>
                    {t("LBL_FILL_DELIM")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                     {t('LBL_QUICK_CODESET_ADD_CUSTOMIZE_DIALOG_DELIM_MESSAGE')}
                    </Typography>
                    <FormControl
                      className='width-100 margin-top-16'
                      size='small'>
                     <ItemPropertiesDelimiterInput
                      label={t('RECORD_DELIMITER')}
                      value={recordDelimiterValue}
                      name={"dataValiadtionRecordDelim"}
                      source={"DATA_VALIDATION"}
                     />

                    </FormControl>
                    <FormControl className="width-100 margin-top-16" size="small">
                    <ItemPropertiesDelimiterInput
                      label={t("LBL_FLD_DELIM")}
                      value={fieldDelimiterValue}
                      name={"dataValiadtionFieldDelim"}
                      source={"DATA_VALIDATION"}
                    />
                  </FormControl>
                </AccordionDetails>
              </Accordion>

            </div>
            <div style={{ display:'flex', justifyContent:'flex-end',paddingTop:'9px'}}>
                <FormControl>
                    <Button variant='outlined' size='small' className='margin-right-4' onClick={handleDone}>
                        {t('BTN_DONE')}
                    </Button>
                </FormControl>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default DataValidationCustomizeScreen